import { BrandColors, Colors } from "@/constants/theme";
import React from "react";
import {
  ActivityIndicator,
  StyleSheet,
  TouchableOpacity,
  View,
  Modal,
  useColorScheme,
} from "react-native";
import { ThemedText } from "./themed-text";

export const LogOutModal = ({
  visible,
  onCancel,
  onConfirm,
  loading,
}: {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  loading: boolean;
}) => {
  const colorScheme = useColorScheme();
  const theme = Colors[colorScheme ?? "light"];
  
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onCancel}
    >
      <View style={styles.modalOverlay}>
        <View
          style={[styles.modalContent, { backgroundColor: theme.background }]}
        >
          <ThemedText style={styles.modalTitle} type="defaultSemiBold">
            Log Out
          </ThemedText>
          <ThemedText style={styles.modalMessage}>
            Are you sure you want to log out?
          </ThemedText>
          <View style={styles.modalButtons}>
            <TouchableOpacity
              testID="logout_cancel"
              style={[
                styles.modalButton,
                styles.cancelButton,
                { borderColor: theme.border },
              ]}
              onPress={onCancel}
              disabled={loading}
            >
              <ThemedText type="defaultSemiBold">Cancel</ThemedText>
            </TouchableOpacity>
            <TouchableOpacity
              testID="logout_confirm"
              style={[
                styles.modalButton,
                styles.confirmButton,
                loading && styles.disabledButton,
              ]}
              onPress={onConfirm}
              disabled={loading}
            >
              {loading ? (
                <ActivityIndicator color="#fff" size="small" />
              ) : (
                <ThemedText
                  style={styles.confirmButtonText}
                  type="defaultSemiBold"
                >
                  Log Out
                </ThemedText>
              )}
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  modalContent: {
    width: "100%",
    maxWidth: 340,
    borderRadius: 16,
    padding: 24,
    gap: 16,
  },
  modalTitle: {
    fontSize: 18,
    textAlign: "center",
  },
  modalMessage: {
    textAlign: "center",
    lineHeight: 22,
  },
  modalButtons: {
    flexDirection: "row",
    gap: 12,
  },
  modalButton: {
    flex: 1,
    minHeight: 48,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  cancelButton: {
    borderWidth: 1,
  },
  confirmButton: {
    backgroundColor: BrandColors.error,
  },
  confirmButtonText: {
    color: BrandColors.white,
  },
  disabledButton: {
    opacity: 0.7,
  },
});
